import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
    BedDouble,
    Activity,
    BarChart2,
    UserPlus,
    LogOut,
    Briefcase,
    FileText,
    Settings,
    CalendarCheck // [NEW]
} from 'lucide-react';

const navItems = [
    { id: "beds", name: "Leitos", icon: <BedDouble size={24} />, path: "/" },
    { id: "nir", name: "NIR", icon: <CalendarCheck size={24} />, path: "/reservations" }, // [NEW]
    { id: "metrics", name: "Métricas", icon: <BarChart2 size={24} />, path: "/metrics" },
    { id: "checkin", name: "Check-in", icon: <UserPlus size={24} />, path: "/checkin" },
    { id: "checkout", name: "Check-out", icon: <LogOut size={24} />, path: "/checkout" },
    { id: "services", name: "Serviços", icon: <Briefcase size={24} />, path: "/services" },
];

export function BottomNavigation() {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuth();

    const hasPermission = (perm) => {
        if (!user) return false;
        // Se for admin ou tiver a permissão
        if (user.role_name === 'Administrador') return true;
        return user.permissions?.includes(perm);
    };

    const finalNavItems = navItems.filter(item => {
        if (item.id === 'nir') return hasPermission('access_nir');
        // Outros itens podem ter permissões também, mas o foco agora é NIR
        return true;
    });

    // Se estiver em rota pública (login ou public dashboard), não mostrar
    if (location.pathname === '/login' || location.pathname.includes('/public')) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 px-4 py-2 flex justify-around items-center z-50 safe-area-bottom shadow-lg">
            {finalNavItems.map(item => {
                const isActive = location.pathname === item.path;
                return (
                    <button
                        key={item.id}
                        onClick={() => navigate(item.path)}
                        className={`flex flex-col items-center gap-1 p-2 rounded-xl transition-all ${isActive
                            ? 'text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/30 font-medium transform scale-105'
                            : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800'
                            }`}
                    >
                        {item.icon}
                        <span className="text-xs">{item.name}</span>
                    </button>
                );
            })}
            <button
                onClick={() => navigate('/settings')}
                className={`flex flex-col items-center gap-1 p-2 rounded-xl transition-all ${location.pathname === '/settings'
                    ? 'text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/30 font-medium transform scale-105'
                    : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800'
                    }`}
            >
                <Settings size={24} />
                <span className="text-xs">Ajustes</span>
            </button>
        </div>
    );
}
